import React from 'react';
import { css } from 'linaria';
import { styled } from 'linaria/react';

export const panel = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 32px 24px 24px;

  @media (--only-mobile) {
    padding: 16px 16px 8px;
  }
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 8px;
  cursor: pointer;

  @media (--only-mobile) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 8px;
  }
`;

export const panelIcon = css`
  margin-right: 24px;

  @media (--only-mobile) {
    margin-right: 0;
    margin-bottom: 20px;
  }
`;

export const panelTitleWrapper = css`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const panelArrowIcon = css`
  transition: all 0.5s ease;
`;

export const openPanelArrowIcon = css`
  transform: rotate(-180deg);
`;

type PanelBodyProps = {
  height: string;
  isOpen: boolean;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const PanelBody = styled.div<PanelBodyProps>`
  height: ${({ height }: PanelBodyProps) => height};
  overflow: hidden;
  transform: rotate(0.01deg);
  transition: all 0.5s ease;
  transition: all 0.5s ease;
  transition: all 0.5s ease;
`;
